import React from "react";
import Icon from "components/AppIcon";

export default function TermsModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-slate-900 border border-white/10 rounded-2xl w-full max-w-lg max-h-[80vh] flex flex-col shadow-2xl">
        <div className="flex items-center justify-between p-6 border-b border-white/10">
          <h2 className="text-lg font-bold text-white font-heading">Terms & Conditions</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center text-slate-400 hover:text-white transition-colors"
          >
            <Icon name="X" size={16} />
          </button>
        </div>
        <div className="overflow-y-auto p-6 space-y-4 text-sm text-slate-400 font-body leading-relaxed">
          <p className="text-slate-300 font-medium">Last updated: March 2026</p>
          <p>By creating an account on myfitnesstracking, you agree to be bound by these Terms and Conditions. Please read them carefully before proceeding.</p>
          <h3 className="text-white font-semibold font-caption">1. Account Registration</h3>
          <p>You must provide accurate, current, and complete information during the registration process. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
          <h3 className="text-white font-semibold font-caption">2. Subscription & Billing</h3>
          <p>Free trial accounts are valid for 14 days with no credit card required. After the trial period, continued use requires a paid subscription. Billing occurs monthly or annually based on your selected plan. You may cancel at any time before the next billing cycle.</p>
          <h3 className="text-white font-semibold font-caption">3. Data & Privacy</h3>
          <p>We collect and process data in accordance with our Privacy Policy. Your gym member data remains your property. We do not sell or share your data with third parties without explicit consent.</p>
          <h3 className="text-white font-semibold font-caption">4. Acceptable Use</h3>
          <p>You agree not to use myfitnesstracking for any unlawful purpose, to upload malicious content, or to attempt to gain unauthorized access to our systems or other users' accounts.</p>
          <h3 className="text-white font-semibold font-caption">5. Service Availability</h3>
          <p>We strive for 99.9% uptime but do not guarantee uninterrupted service. Scheduled maintenance will be communicated in advance. We are not liable for losses resulting from service interruptions.</p>
          <h3 className="text-white font-semibold font-caption">6. Termination</h3>
          <p>We reserve the right to suspend or terminate accounts that violate these terms. You may delete your account at any time, and your data will be removed within 30 days of deletion.</p>
        </div>
        <div className="p-6 border-t border-white/10">
          <button
            onClick={onClose}
            className="w-full h-10 rounded-xl bg-primary hover:bg-primary/90 text-white font-semibold text-sm font-caption transition-colors"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}
